import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  onlineTitle: {
    id: 'frontbucket.flags.network.onlineTitle',
    description: 'Text for the title of the online message',
    defaultMessage: 'Connected',
  },
});
